import { ApiItemType, ApiGender } from '@ibe/api';
import { NoteLevelsType } from './ConfigModel.js';
import HotelRoomView from './HotelRoomView.js';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultConfig = {
  defaultLanguage: 'en',
  apiUrl: '/',
  configUrl: '/config.json',
  translationsUrl: '',
  sessionKeyTabsShared: true,
  sessionKeyAuth: 'IBE_AUTH',
  sessionKeyApp: 'IBE_APP',
  sessionKeyCart: 'IBE_CART',
  sessionKeyPackageCart: 'IBE_PACKAGE_CART',
  sessionKeyCookieLaw: 'IBE_COOKIES',
  sessionKeyCurrency: 'IBE_CURRENCY',
  sessionKeyDiscardedRecommendations: 'IBE_DISCARDED_RECOMMENDATIONS',
  sessionKeySearchParams: 'IBE_SEARCH_PARAMS',
  formatDate: 'YYYY-MM-DD',
  formatTime: 'HH:mm',
  datePickerMinDateOffset: 1,
  roomsLeftMaxToDisplay: 5,
  offersLeftMaxToDisplay: 5,
  displayFormatDate: {
    de_DE: 'DD.MM.YYYY',
    en_US: 'MM/DD/YYYY'
  },
  displayFormatDateShort: {
    de_DE: 'DD. MMM',
    en_US: 'DD MMM'
  },
  displayFormatDateTime: {
    de_DE: 'DD.MM.YYYY HH:mm',
    en_US: 'MM/DD/YYYY HH:mm'
  },
  displayFormatWeekDay: {
    de_DE: 'ddd, DD.MM.YYYY',
    en_US: 'ddd, MM/DD/YYYY'
  },
  googleApiKey: '',
  googleReCaptchaKey: '6Lc3LOIZAAAAAJvtC3EtvkE0P_hNvkRQjkjSRGgW',
  googleAnalyticsTrackingId: null,
  googleTagManagerContainerId: null,
  useIndexedGeoUnits: false,
  useConsentManager: false,
  pageToRoute: _defineProperty({}, ApiItemType.HOTEL, {
    page: ''
  }),
  defaultCurrency: 'EUR',
  currency: 'EUR',
  session: {
    expirationTimeNotificationOffset: 5,
    expirationTime: 5
  },
  serviceCharacteristics: _defineProperty(_defineProperty({}, ApiItemType.EXTRA, {
    language: 'LANGUAGE',
    exertionLevel: 'EXERTION_LEVEL'
  }), ApiItemType.HOTEL, {
    amenities: 'AMENITIES',
    facilities: 'FACILITIES'
  }),
  unitOptions: {
    noSelection: 'NOMEAL',
    showTAC: false
  },
  theme: null,
  traveler: {
    genderValues: Object.values(ApiGender),
    maxChildAge: 17,
    maxChildAgeFlightSearch: 17,
    maxInfantAge: 2,
    mockAvailable: true,
    treatInfantsAsChildren: false
  },
  headerScrollOffset: {
    mobile: 0,
    tablet: 0,
    desktop: 0
  },
  scrollDuration: 500,
  components: {
    voucherBuyerForm: {
      showFiscalCode: false,
      showState: true
    },
    voucherPaymentSection: {
      showTaxes: false
    },
    hotelRoomView: HotelRoomView.GROUPEDBYROOMCONFIG
  },
  scrollOffsets: {
    header: 0
  },
  externalParam: {
    delimiter: '|'
  },
  tracking: {
    hotjar: {
      hjid: null,
      hjsv: null
    }
  },
  exactSearchDurationOptions: {
    WEEKS: [1, 2, 3, 4],
    NIGHTS: _toConsumableArray(Array.from({
      length: 28
    }, function (_, i) {
      return i + 1;
    }).filter(function (i) {
      return i > 2;
    }))
  },
  packageSearchDurationOptions: {
    WEEKS: [1, 2, 3, 4],
    NIGHTS: _toConsumableArray(Array.from({
      length: 28
    }, function (_, i) {
      return i + 1;
    }).filter(function (i) {
      return i > 2;
    }))
  },
  stickySearchOffsetClass: '',
  forms: {
    excludeSalutations: [],
    showConfirmEmailField: true
  },
  roundPricesToWholeNumber: undefined,
  summaryComponentParams: {
    packageItemType: {
      showTitle: true,
      filterNote: true
    }
  },
  useTid: true,
  tenant: null,
  affiliate: null,
  noteSortingOrder: [NoteLevelsType.GLOBAL, NoteLevelsType.SERVICE, NoteLevelsType.UNIT],
  calendar: {
    weekStartsOn: {
      en: 1 /* Monday */
    }
  },
  modalContainerClass: 'its',
  payment: {
    messagingEnabled: true
  },
  paxRoomConfig: {
    minAdults: 1,
    maxAdults: 10,
    maxChildren: 10,
    maxChildAge: 17,
    maxCapacity: 9,
    maxRooms: 9
  },
  sanitizeConfig: {
    allowIframes: false
  }
};

export { defaultConfig as default };
//# sourceMappingURL=defaultConfig.js.map
